import { checkin as en_checkin } from "../en/checkin";

/** checkin — RU slice (120 keys). */
export const checkin: Record<keyof typeof en_checkin, string> = {
  checkin_launcher_subtitle:
    "Отметься на ближайшем событии Linqx, чтобы знакомиться, играть и зарабатывать CP — открой «Отметиться», чтобы начать.",
  checkin_launcher_open_button: "Отметиться",
  checkin_map_title: "Отметиться",
  checkin_map_tap_event: "Нажми на событие на карте, чтобы отметиться",
  checkin_map_no_nearby: "Рядом сейчас нет событий Linqx.",
  checkin_map_location_denied:
    "Геолокация выключена. Включи её, чтобы находить события рядом, или отсканируй QR.",
  checkin_map_you_are_here: "Ты здесь",
  checkin_map_scan_instead: "Сканировать для отметки",
  checkin_card_check_in_button: "Отметиться",
  checkin_card_scan_button: "Сканировать для отметки",
  checkin_card_try_again_button: "Попробовать снова",
  checkin_card_potential_linqx: "{count} возможных Linqx",
  checkin_card_geofence_error:
    "Ты ещё не на месте — примерно в {distance} м. Подойди ближе и попробуй снова.",
  checkin_scan_title: "Новая отметка",
  checkin_scan_point_camera: "Наведи камеру на QR-код события.",
  checkin_scan_camera_help:
    "Включи камеру для сканирования или вставь код события ниже.",
  checkin_scan_enable_camera: "Включить камеру",
  checkin_scan_paste_placeholder: "Вставь код события",
  checkin_scan_submit: "Отметиться",
  checkin_scan_checking_in: "Отмечаемся…",
  checkin_scan_invalid_code: "Это не похоже на код для отметки на событии.",
  checkin_back: "Назад",
  checkin_back_to_dashboard: "Назад на главную",
  checkin_activity_coming_soon: "Эта активность скоро появится.",
  checkin_dashboard_checked_in: "Ты отметился!",
  checkin_dashboard_cp_amount: "+{cp} CP",
  checkin_dashboard_qr_connect: "QR-коннект",
  checkin_dashboard_activities: "Активности",
  checkin_dashboard_top_mixers: "Топ участников",
  checkin_dashboard_see_full_board: "Смотреть весь рейтинг",
  checkin_dashboard_no_active: "Ты ещё не отметился ни на одном событии.",
  checkin_dashboard_back_to_map: "Назад к карте",
  checkin_activity_speed_linq: "Speed Linq",
  checkin_activity_mini_games: "Мини-игры",
  checkin_activity_photo: "Фотозадание",
  checkin_activity_social_share: "Поделиться",
  checkin_activity_invite: "Пригласить друзей",
  checkin_action_play: "Играть",
  checkin_action_join: "Присоединиться",
  checkin_action_camera: "Камера",
  checkin_action_share: "Поделиться",
  checkin_action_invite: "Пригласить",
  checkin_photo_title: "Фотозадание",
  checkin_photo_timeline_hint: "Лента события · +10 CP за фото",
  checkin_photo_empty: "Пока нет фото. Поделись первым!",
  checkin_photo_just_now: "только что",
  checkin_photo_take: "Сделать фото",
  checkin_photo_cap_reached: "Ты выложил все 3 своих фото.",
  checkin_photo_remaining: "Осталось фото: {count}",
  checkin_photo_report: "Пожаловаться",
  checkin_photo_reported: "Жалоба отправлена.",
  checkin_photo_submitting: "Загрузка…",
  checkin_leaderboard_title: "Топ участников",
  checkin_leaderboard_empty:
    "Пока никто не в рейтинге. Зарабатывай CP, чтобы подняться!",
  checkin_leaderboard_finalized: "Итоговые результаты",
  checkin_leaderboard_updates: "Обновляется каждые 2 мин",
  checkin_leaderboard_pts: "{count} очк.",
  checkin_leaderboard_you: "Ты",
  checkin_invite_title: "Пригласить друзей",
  checkin_invite_heading: "Приглашай друзей, получай 25 CP",
  checkin_invite_subtitle:
    "Получай +25 CP каждый раз, когда друг присоединится по твоему коду и завершит настройку.",
  checkin_invite_your_code: "Твой реферальный код",
  checkin_invite_copy: "Скопировать код",
  checkin_invite_copied: "Скопировано ✓",
  checkin_invite_how_it_works: "Как это работает",
  checkin_invite_step_1: "Поделись своим кодом с другом",
  checkin_invite_step_2: "Он вводит его при регистрации",
  checkin_invite_step_3: "Он проходит онбординг",
  checkin_invite_step_4: "Ты получаешь +25 CP",
  checkin_invite_footnote:
    "Реферал по событиям — только по коду. Начисления видны в истории очков.",
  checkin_games_title: "Мини-игры",
  checkin_games_join_heading: "Присоединиться к игре",
  checkin_games_code_placeholder: "Введи код, чтобы присоединиться",
  checkin_games_join_button: "Войти в игру →",
  checkin_games_live_heading: "Сейчас идёт на этом событии",
  checkin_games_join: "Присоединиться",
  checkin_games_type_who_said_it: "Кто это сказал?",
  checkin_games_type_two_truths: "Две правды и ложь",
  checkin_games_status_lobby: "Ждём игроков…",
  checkin_games_status_in_progress: "Идёт игра",
  checkin_games_players: "{count} игроков",
  checkin_games_code_label: "Код {code}",
  checkin_games_empty: "Пока нет игр — организатор ещё не начал ни одной.",
  checkin_games_organizer_note: "Игры запускает организатор",
  checkin_games_joining: "Подключаемся…",
  checkin_game_title_who_said_it: "Кто это сказал?",
  checkin_game_title_two_truths: "Две правды и ложь",
  checkin_game_round: "Раунд {current}/{total}",
  checkin_game_waiting: "Ждём начала раунда…",
  checkin_game_prompt_who_said_it: "Кто это сказал?",
  checkin_game_prompt_two_truths: "Что из этого ложь?",
  checkin_game_your_score: "Твой счёт {score}",
  checkin_game_next: "Дальше →",
  checkin_game_finish: "Завершить →",
  checkin_game_over: "Игра окончена",
  checkin_game_final_score: "Итоговый счёт {score}",
  checkin_game_completed: "завершено",
  checkin_game_completed_winner: "завершено + победа",
  checkin_game_capped: "Достигнут дневной лимит CP за игры",
  checkin_game_back_to_event: "Назад к событию",
  checkin_game_ended: "Эта игра завершена.",
  checkin_game_dropped: "Тебя исключили из игры — CP не начислены.",
  checkin_speed_title: "Speed Linq",
  checkin_speed_intro_heading: "60 секунд. Жми быстро.",
  checkin_speed_intro_body:
    "Лайкай тех, с кем хочешь познакомиться, пока не вышло время. Получи +10 CP за игру.",
  checkin_speed_start: "Начать",
  checkin_speed_like: "Лайк",
  checkin_speed_skip: "Пропустить",
  checkin_speed_already_liked: "Лайкнуто",
  checkin_speed_time_left: "{seconds} с",
  checkin_speed_empty: "Тут пока некого встретить — загляни позже.",
  checkin_speed_done_heading: "Время вышло!",
  checkin_speed_liked_count: "Ты лайкнул {count} человек",
  checkin_speed_done: "Готово",
  checkin_share_title: "Поделись событием",
  checkin_share_subtitle: "#LinqxMixer · +25 CP, когда вернёшься",
  checkin_share_shared_heading: "Отправлено! Вернись, чтобы получить награду",
  checkin_share_credited_note:
    "(начисляется при возврате, один раз за событие)",
  checkin_share_done: "Готово",
  checkin_share_already:
    "Ты уже получил CP за то, что поделился этим событием.",
};
